import {OperatorApplicationConfigInstance} from "~/operatorApplication/ts/service/OperatorApplicationConfig";
import OperatorApplicationPlatform from "~/operatorApplication/ts/platform/OperatorApplicationPlatformFactory";
import OperatorApplicationBuddyList from "~/operatorApplication/ts/service/OperatorApplicationBuddyList";
import playNotificationSoundAboutClientMessage
    from "~/operatorApplication/ts/service/dialog/PlayNotificationSoundAboutClientMessage";
import getCurrentDialogOfClient from "~/operatorApplication/ts/service/buddyList/getCurrentDialogOfClient";
import IconInterface from "~/cabinet/vue/interface/icon/IconInterface";
import {OperatorAccountStore} from "~/operatorApplication/ts/store/OperatorAccountStore";
import {getFaviconUrl} from "~/core-ui/ts/CoreUiHelpersMixin";
import StringHelper from "~/ts/library/StringHelper";
import CoreUiChatHistoryHelper from "~/core-ui/vue/chat/CoreUiChatHistoryHelper";
import Delay from "~/ts/library/Delay";
import {
    EVENT_OPEN_CROSS_OPERATOR_CONVERSATION_TAB,
    OperatorApplicationEventManager
} from "~/operatorApplication/ts/OperatorApplicationEventManager";
import {ClientUserdataStore} from "~/operatorApplication/ts/store/ClientUserdataStore";
import {__} from "~/ts/library/Translate";

export function getIconForNotificationByClient(client: OperatorApplicationApi.OperatorApplicationClientOpenApiModel): IconInterface | null {
    let icon: IconInterface = null;
    if (client.integration) {
        let platform = OperatorAccountStore.integrationPlatformDictionary.value[client.integration.aggregationPlatformId ?? client.integration.platformId];
        if (platform) {
            icon = {
                color: platform.iconColor,
                imgIcon: platform.iconImg,
                fontAwesomeIcon: platform.icon
            };
        }
    } else {
        let site = OperatorAccountStore.sitesDictionary.value[client.siteId];
        if (site) {
            icon = {
                color: "#000000",
                imgIcon: getFaviconUrl(site.domain),
                fontAwesomeIcon: "globe"
            }
        }
    }
    return icon;
}

export default function showNotificationAboutClientMessage(
    client: OperatorApplicationApi.OperatorApplicationClientOpenApiModel,
    text: string,
    notifySoundOnce?: boolean,
    notificationSettings?: CometOperatorApplication.MessageOperatorNotificationConfigOpenApiModel
) {
    if (OperatorApplicationConfigInstance.newMessageNotificationsEnabled) {
        text = notificationSettings?.text ?? text;
        if (text) {
            if (CoreUiChatHistoryHelper.isOneOfCrossOperatorsChat(client)) {
                text = StringHelper.htmlToText(StringHelper.bbcodeToHtml(text));
            }
        }

        let clientDisplayDescr = client.displayDescr;
        if (client.type.isCrossOperatorsConversationChat) {
            let parentUsername = client.crossOperatorConversationParams?.parentUsername;
            if (parentUsername) {
                let parent = ClientUserdataStore.getByUsername(parentUsername, false);
                if (parent) {
                    clientDisplayDescr = __('Обсуждение') + ` - ${parent.displayDescr}`;
                }
            }
        }

        OperatorApplicationPlatform.notifications.show({
            groupId: client.username,
            title: notificationSettings?.title ?? clientDisplayDescr,
            text: notificationSettings?.text ?? text,
            click: async () => {
                if (client.type.isCrossOperatorsChat) {
                    OperatorApplicationBuddyList.openClientByUsername(client.username);
                } else if (client.type.isCrossOperatorsConversationChat) {
                    let parentUsername = client.crossOperatorConversationParams?.parentUsername;
                    if (parentUsername) {
                        OperatorApplicationBuddyList.addClientAndOpenByUsername(parentUsername);
                        await Delay.make(500);
                        OperatorApplicationEventManager.emit(EVENT_OPEN_CROSS_OPERATOR_CONVERSATION_TAB, parentUsername);
                    }
                } else {
                    OperatorApplicationBuddyList.addClientAndOpenByUserdata(client);
                }
            },
            avatarUrl: notificationSettings?.avatarUrl,
            icon: getIconForNotificationByClient(client),
            autoCloseSeconds: notificationSettings?.autoCloseSeconds
        });
        if (!OperatorApplicationPlatform.notifications.hasByGroupId(client.username)) {
            let dialog = getCurrentDialogOfClient(client);
            playNotificationSoundAboutClientMessage(client, !dialog, notifySoundOnce);
        }
    }
}